import { defineStore } from 'pinia'
import { ref } from "vue"
import { toast } from "vue3-toastify"

import http from "@/plugins/http.js"

export const useAvailablePurchasesStore = defineStore( 'availablePurchases', () => {
  const applicablePurchase = ref( null )
  const useFreeGame = ref( false )

  function getAvailablePurchases( redirectOnNoPurchase = true ) {
    return new Promise( ( resolve, reject ) => {
      http
        .get( 'games/can-play' )
        .then( ( response ) => {
          applicablePurchase.value = response.data
          resolve( response )
        })
        .catch( ( err ) => {
          if ( err.response.status === 404 ) {
            toast.error( "You do not have any active purchases found - please purchase a game or subscription!" )
            useFreeGame.value = false
            applicablePurchase.value = null
            if ( redirectOnNoPurchase ) {
              this.router.push( { name: 'prices' } )
              reject( err )
            }
            else {
              resolve( -1 )
            }
          }
          else if ( err.response.status === 418 ) {
            toast.warning( "You only have your one free game available!" )
            useFreeGame.value = true
            resolve( -1 )
          }
          else {
            toast.error( err.response.data.detail )
            reject( err )
          }
        })
    })
  }

  return { applicablePurchase, useFreeGame, getAvailablePurchases }
})